import { render, staticRenderFns } from "./goodsLevel.vue?vue&type=template&id=7ef74732"
import script from "./goodsLevel.vue?vue&type=script&lang=js"
export * from "./goodsLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports